import React, { FC } from 'react';
import type { LayoutProps } from 'antd';

import BaseLayout from 'components/BaseLayout';
import type { RouterProps } from 'router/routeUrl';
import menuAboutUs from 'assets/imgs/menu_about-us.png';
import menuGames from 'assets/imgs/menu_games.png';

const arcadeMenuItems: RouterProps[] = [
  {
    path: '/arcade-landing/games',
    menuName: 'nav.games',
    component: null,
    menuIcon: menuGames,
    color: 'cyan',
  },
  {
    path: '/arcade-landing/about-us',
    menuName: 'nav.about',
    component: null,
    menuIcon: menuAboutUs,
    color: 'orange',
  },
];

interface ArcadeLayoutProps extends LayoutProps {
  className?: string;
}

const ArcadeLayout: FC<ArcadeLayoutProps> = ({ children, className }) => {
  return (
    <BaseLayout className={className} menu={arcadeMenuItems} homePath="/arcade-landing">
      {children}
    </BaseLayout>
  );
};

export default ArcadeLayout;
